"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLineItemTypeUpsert = exports.ServiceLineItemTypeUpdate = exports.ServiceLineItemTypeCreate = exports.ServiceLineItemType = exports.DefaultLineItemTypes = exports.ServiceLineItemUnitType = exports.ServiceLineItemUnitTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.ServiceLineItemUnitTypes = [
    'ton',
    'hour',
    'day',
    'week',
    'month',
    'each',
    // TODO: More? Hopefully not :-P
];
exports.ServiceLineItemUnitType = typebox_1.Type.Union(exports.ServiceLineItemUnitTypes.map((type) => typebox_1.Type.Literal(type)));
exports.DefaultLineItemTypes = ['delivery', 'removal', 'cancellation', 'misc. fee', 'recurring'];
exports.ServiceLineItemType = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    /**
     * Description is improperly named. It should be called "name" - TODO: Fix this
     */
    description: typebox_1.Type.String(),
    displayName: typebox_1.Type.String(),
    rfpHelperText: typebox_1.Type.Optional(typebox_1.Type.String()),
    rfpAlwaysGetPrice: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    basePrice: typebox_1.Type.Integer(), // In cents. Use 0 if purely unit priced.
    baseCost: typebox_1.Type.Integer(), // In cents. Use 0 if purely unit priced.
    unitPrice: typebox_1.Type.Integer(), // In cents. Use 0 if flat rate.
    unitCost: typebox_1.Type.Integer(), // In cents. Use 0 if flat rate.
    unitType: exports.ServiceLineItemUnitType,
    taxable: typebox_1.Type.Boolean(),
    minQuantity: typebox_1.Type.Integer(),
    internalNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    active: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
exports.ServiceLineItemTypeCreate = typebox_1.Type.Omit(exports.ServiceLineItemType, ['id', 'metadata']);
exports.ServiceLineItemTypeUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.ServiceLineItemType, ['metadata']));
exports.ServiceLineItemTypeUpsert = typebox_1.Type.Intersect([
    exports.ServiceLineItemTypeCreate,
    typebox_1.Type.Object({
        id: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
//# sourceMappingURL=ServiceLineItemType.js.map